"use client";

import Image from "@/components/Image";
import React, { useState } from "react";

const Bottom = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <section className="w-full bg-[#333333]">
      {/*更多信息*/}
      <div className="w-full flex flex-col items-center bg-[#333333] px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px]">
        <div className="w-full max-w-[1360px] h-[567px] pt-[80px] pb-[120px] flex flex-col gap-[110px]">
          <div className="w-full h-[220px] flex justify-between">
            {/*左侧文字*/}
            <div className="flex flex-row gap-[clamp(10px,4vw,100px)]">
              {/*蜜蜂家校*/}
              <div className="flex flex-col gap-[10px] max-w-[180px]">
                <div className="w-[132px] h-[34px]">
                  <Image
                    src="/logo_10.png"
                    alt="蜜蜂试卷"
                    width={132}
                    height={34}
                  />
                </div>
                <div className=" font-light text-[14px] leading-[24px] tracking-[0px] text-[#FFF]">
                  蜜蜂家校是一个提供一站式 AI
                  技术赋能教与学解决方案落地的平台，产品包含多样化作业管理、AI
                  精准学情分析、全场景家校沟通等，旨在投身教育，终身学习，成就不同精彩人生。
                </div>
              </div>
              {/*关于*/}
              <div className="flex flex-col gap-[10px] min-w-[84px]">
                <div className="font-[PingFang-SC] font-semibold text-[18px] leading-[34px] tracking-[0px] text-[#FFFFFF]">
                  关于
                </div>
                <a
                  href="/aboutus"
                  rel="nofollow"
                  className="font-[PingFang-SC] font-normal text-[14px] leading-[28px]  tracking-[0px] text-[#FFFFFF] hover:text-[#1DBA55]"
                >
                  关于蜜蜂家校
                </a>
                <a
                  href="https://static-cdn-p.mifengjiaoyu.com/policy/mifengjiaxiao_web/service_zh-cn.html"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="font-[PingFang-SC] font-normal text-[14px] leading-[28px] tracking-[0px] text-[#FFFFFF] hover:text-[#1DBA55]"
                >
                  用户协议
                </a>
                <a
                  href="https://static-cdn-p.mifengjiaoyu.com/policy/mifengjiaxiao_web/privacy_zh-cn.html"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="font-[PingFang-SC] font-normal text-[14px] leading-[28px] tracking-[0px] text-[#FFFFFF] hover:text-[#1DBA55]"
                >
                  隐私政策
                </a>
              </div>
              {/*校方*/}
              <div className="flex flex-col gap-[10px] min-w-[98px]">
                <div className="font-[PingFang-SC] font-semibold text-[18px] leading-[34px] tracking-[0px] text-[#FFFFFF]">
                  我是校方
                </div>
                <a
                  href="https://xy.mifengjiaoyu.com/login"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="font-[PingFang-SC] font-normal text-[14px] leading-[28px] tracking-[0px] text-[#FFFFFF] hover:text-[#1DBA55]"
                >
                  校园版操作平台
                </a>
                <a
                  href="https://mifengjiaoyu.feishu.cn/wiki/MaHXwo0USiWsrhkSLMTcHYTsnfb"
                  target="_blank"
                  rel="nofollow"
                  className="font-[PingFang-SC] font-normal text-[14px] leading-[28px] tracking-[0px] text-[#FFFFFF] hover:text-[#1DBA55]"
                >
                  新手指南
                </a>
              </div>
              {/*服务商*/}
              <div className="flex flex-col gap-[10px] min-w-[98px]">
                <div className="font-[PingFang-SC] font-semibold text-[18px] leading-[34px] tracking-[0px] text-[#FFFFFF]">
                  我是服务商
                </div>
                <a
                  href="https://mifengjiaoyu.feishu.cn/share/base/form/shrcng2mebO4szvD0RIF6nQYbmb?prefill_%E5%90%88%E4%BD%9C%E7%8A%B6%E6%80%81=0%25+%E5%85%AC%E6%B5%B7&hide_%E5%90%88%E4%BD%9C%E7%8A%B6%E6%80%81=1"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="font-[PingFang-SC] font-normal text-[14px] leading-[28px] tracking-[0px] text-[#FFFFFF] hover:text-[#1DBA55]"
                >
                  代理合作
                </a>
              </div>
            </div>
            {/*右侧图片*/}
            <div className="relative min-w-[120px]">
              {/* 放大后的图片（默认隐藏） */}
              {isHovered && (
                <div className="absolute h-[224px] w-[682px] bottom-full mb-2 right-0 shadow-xl rounded-lg overflow-hidden">
                  <Image
                    src="/education_hover_10.png"
                    alt="教育应用备案大图"
                    width={682}
                    height={224}
                  />
                </div>
              )}
              <div
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                className="cursor-pointer"
              >
                <Image
                  src="/education_filing_10.png"
                  alt="教育应用备案小图"
                  width={159}
                  height={220}
                />
              </div>
            </div>
          </div>
          {/*备案信息*/}
          <div className="w-full flex flex-row gap-[77px]">
            <div className="font-[PingFang-SC] font-normal text-[14px] leading-[24px] tracking-[0px] text-[#FFFFFF73]">
              上海临冠数据科技有限公司
              <br />
              公司地址：上海市静安区万荣路1268号云立方A座11层
              <br />
              违法和不良信息举报电话：021-26022790
            </div>
            <div className="font-[PingFang-SC] font-normal text-[14px] leading-[24px] tracking-[0px] text-[#FFFFFF73]">
              <div>版权所有 ©上海临冠数据科技有限公司</div>
              <div className="w-full">
                <a
                  href="https://beian.miit.gov.cn/#/Integrated/index"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="mr-[20px]"
                >
                  沪 ICP备18021381号-7
                </a>
                <a
                  href="https://beian.mps.gov.cn/#/query/webSearch"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="mr-[20px]"
                >
                  沪公网安备 31010602006688号
                </a>
              </div>

              <div className="relative inline-block group pt-[5px]">
                <Image
                  src="/pic1_xy_04.png"
                  alt="营业执照"
                  width={74}
                  height={24}
                  className="block cursor-pointer"
                />
                <Image
                  src="/pic2_xy_04.png"
                  alt="hover显示的图片"
                  width={1109}
                  height={767}
                  className="absolute -left-[30vh] -top-[80vh] hidden group-hover:block z-10 w-auto h-[80vh]  max-w-none"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Bottom;
